export default __webpack_public_path__ + "static/img/vogue_scene_animated_0691.92ae876.jpg";